import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { fetchMe, deleteTotp, clearDeleteTotp } from 'redux/users/actions';

import CommonModal from 'components/elements/modals/CommonModal';
import Button from 'components/elements/buttons/Button';

import './TwoFactorDisconnectModal.css';

function TwoFactorDisconnectModal(props) {
  const {
    onClose,
    open,
    fetchMe,
    deleteTotp,
    clearDeleteTotp,
    deleteTtopSuccess,
    deleteTtopError,
  } = props;
  const { t } = useTranslation();

  useEffect(() => {
    if (deleteTtopSuccess) {
      onClose();
      clearDeleteTotp();
      setTimeout(() => {
        fetchMe();
      }, 500);
    }
  }, [deleteTtopSuccess]);

  return (
    <CommonModal
      className="two-factor-disconnect-modal__component"
      open={open}
      onClose={onClose}
    >
      <div className="header">{t("Two Factor Authentication")}</div>

      <div className="content-wrapper">
        <strong>{t("This Will Turn Off Two-Factor Authentication")}</strong>
        <div className="text">
          {t("You will no longer receive a verification code " +
             "if we notice an attempted login from a device " +
             "or browser we don't recognize.")}
        </div>

        <div className="buttons-block">
          <Button small onClick={deleteTotp}>{t("Turn Off")}</Button>
          <Button small borderedBlue onClick={onClose}>{t("Cancel")}</Button>
        </div>

      </div>
    </CommonModal>
  );
}

TwoFactorDisconnectModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  fetchMe: PropTypes.func.isRequired,
  clearDeleteTotp: PropTypes.func.isRequired,
  deleteTotp: PropTypes.func.isRequired,
  open: PropTypes.bool,
  deleteTtopSuccess: PropTypes.object.isRequired,
  deleteTtopError: PropTypes.object.isRequired,
};

TwoFactorDisconnectModal.defaultProps = {
  open: null,
  deleteTtopSuccess: null,
  deleteTtopError: null,
};

const mapStateToProps = state => (
  {
    deleteTtopSuccess: state.usersReducer.deleteTtopSuccess,
    deleteTtopError: state.usersReducer.deleteTtopError,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchMe,
    deleteTotp,
    clearDeleteTotp,
  },
)(TwoFactorDisconnectModal);
